import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useQuestionSectionStyles = makeStyles(() => ({
  rootContainer: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 45px)",
  },
  headerContainer: {
    flex: "0 0 auto",
  },
  contentContainer: {
    // flex: '1 1 auto',
    overflow: "auto",
    // "&::-webkit-scrollbar": {
    //   width: "10px",
    // },
    // padding: theme.spacing(2),
    // height:'calc(100vh - 372.5px)',
  },
  contentContainerMain: {
    overflow: "auto",
  },
  contentContainerMainFull: {
    width: "calc(100vw - 0px) !important",
  },
  contentContainerMainHaf: {
    width: "calc(100vw - 300px) !important",
  },

  questionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
    color: theme.palette.text.primary,
  },
  questionText: {
    marginBottom: theme.spacing(3),
    lineHeight: 1.6,
    "& img": {
      maxWidth: "100%",
      height: "auto",
    },
  },
  buttonContainer: {
    flex: "0 0 auto",
    // padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  questionNoWrapper: {
    borderBottom: "1px solid #ddd",
    padding: "5px 10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fullScreenBtn: {
    background: "#c9ddf5 !important",
    fontSize: "10px !important",
    fontWeight: "700 !important",
    color: "black !important",
    borderRadius: "0px !important",
  },
  options: {
    color: "#000000",
    fontFamily: "'Jost', sans-serif",
    fontSize: "0.875rem",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    marginLeft: "2.5rem",
    "& input": {
      margin: "0.5rem 1rem",
    },
    "& img": {
      width: "100%",
    },
    "& li": {
      margin: "1rem 0.5rem ",
      listStyle: "upper-latin",
      "&::marker": {
        verticalAlign: "middle",
      },
      "& label": {
        display: "flex",
        "& span": {
          "& p": {
            margin: "0",
          },
        },
      },
    },
  },
  dflex: {
    display: "flex !important",
  },
  flexdirectioncolumn: {
    flexDirection: "column !important",
  },
  numberInput: {
    marginTop: "15px",
    marginLeft: "1rem",
    width: "15%",
    padding: "0.5rem",
    // [theme.breakpoints.down("xs")]: {
    // width: "40%",
    // },
    "@media (max-width:599px)": {
      width: "40%",
    },
  },
  questionsContainerinner: {
    minHeight: "calc(100vh - 300px)",
    paddingLeft: "1rem",
    marginTop: "1rem",
    // overflow: "auto",
    "&::-webkit-scrollbar ": {
      display: "none",
    },
    [theme.breakpoints.down("xs")]: {
      height: "58vh",
    },

    "@media (max-width:599px)": {
      height: "58vh",
    },
  },
  questiontext: {
    color: "#00000",
    fontFamily: "'Jost', sans-serif",
    fontSize: "0.9rem",
    marginLeft: "2rem",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "normal",

    "& p": {
      margin: "0rem 1rem",
    },
    [theme.breakpoints.down("xs")]: {
      "& img": {
        width: "100%",
      },
    },
  },
  upWrapper: {
    padding: "4px 8px 4px 0px",
    display: "flex",
    justifyContent: "end",
    borderTop: "1px solid #ddd",
  },
}));

export default useQuestionSectionStyles;
